import { z } from 'zod';
import { validateAllStepsAccumulate } from '@schemas/scenarios-simulator/validations/validate-all-steps';
import { zodErrorMap } from '@schemas/scenarios-simulator/validations/helpers/zod-error-map';

z.setErrorMap(zodErrorMap);

export {
  SimulationStatusEnum,
  DocumentFormatEnum,
  PresetTypeEnum,
  DocTypeEnum,
  EnergyTypeEnum,
  LogKindEnum,
  ErrorLocationEnum,
  TariffGroupEnum,
  RiskTypeEnum,
} from './enums-definitions';

export { mapStringEnum, mapNumberEnum, mapToBoolean, toNumber } from './transformers';

export { validateCommercialGroup } from './validators';

export {
  MonthlyConsumptionSchema,
  YearlyPricesSchema,
  EnergyPriceInfoDTOSchema,
  RawEnergyPriceProjectionComponentSchema,
  MarginFeeSchema,
  GuaranteeTypeSchema,
  EnergyPriceComponentSchema,
  PriceListCompositionItemSchema,
  PriceListCompositionSchema,
  TaxesSchema,
  TariffLowVoltageSchema,
  TariffMediumVoltageSchema,
  TariffProjectionComponentSchema,
  ICMSProjectionComponentSchema,
  ProjectionComponentsSchema,
} from './energy-schemas';

export {
  ConsumptionHistoryMonthSchema,
  ConsumptionHistorySchema,
  LowVoltageConsumptionPayloadSchema,
  MediumVoltageConsumptionPayloadSchema,
  ConsumptionInfoSchema,
  ContractedDemandInfoSchema,
} from './consumption-schemas';

export { LeadPayloadSchema, CommercialGroupPayloadSchema, CommercialGroupSchema, SellerSchema } from './lead-schemas';

export {
  AbstractPresetPayloadSchema,
  AclAbstractPresetPayloadSchema,
  ACRPresetPayloadSchema,
  ACLClarkePresetPayloadSchema,
  ACLCompetitorPresetPayloadSchema,
  PresetPayloadSchema,
  SimulationUnitPayloadSchema,
  UnitPresetPayloadSchema,
} from './preset-schemas';

export {
  UnitPresetScenarioPayloadSchema,
  ScenarioPayloadSchema,
  SimulationPayloadSchema,
  OptimizedScenarioPayloadSchema,
  SimulationInputsSchema,
  BaseScenarioSchema,
} from './scenario-schemas';

export {
  SimulationErrorSchema,
  SimulationLogSchema,
  SimulationMetadataSchema,
  SimulationProposalSchema,
  AdditionalCostReportModelSchema,
  ScenarioYearReportModelSchema,
  ScenarioProjectionResultModelSchema,
  UnitPresetProjectionHighlightSchema,
  ScenarioProjectionHighlightSchema,
  CostCompositionSchema,
  ConsumptionDataOfMonthSchema,
  SampleMonthSchema,
  UnitYearReportSchema,
  ProjectionResultSchema,
  UnitPresetProjectionSchema,
  ScenarioProjectionSchema,
  SavingInfoSchema,
  ScenarioEconomyComparisonSchema,
  UnitsEconomyComparisonsSchema,
  UnitsBenchmarkingSchema,
  BenchmarkingHighlightSchema,
  SimulationBenchmarkingCaseSchema,
  ScenarioCostInfoSchema,
  GeneralHighlightsSchema,
  SimulationHighlightsSchema,
  SimulationOutputsSchema,
} from './report-schemas';

import { LeadPayloadSchema, SellerSchema } from './lead-schemas';
import { SimulationStatusEnum } from './enums-definitions';
import {
  SimulationMetadataSchema,
  SimulationOutputsSchema,
  ScenarioProjectionSchema,
  SimulationBenchmarkingCaseSchema,
  GeneralHighlightsSchema,
} from './report-schemas';
import { SimulationInputsSchema } from './scenario-schemas';

export const SimulationSchema = z
  .object({
    Id: z.string().nullish(),
    leadInfo: LeadPayloadSchema.nullish(),
    description: z.string().nullish(),
    seller: SellerSchema.nullish(),
    status: SimulationStatusEnum.nullish(),
    metadata: SimulationMetadataSchema.nullish(),
    inputs: SimulationInputsSchema.nullish(),
    outputs: SimulationOutputsSchema.nullish(),
    scenariosProjections: z.array(ScenarioProjectionSchema).nullish(),
    scenarioComparisons: z.array(SimulationBenchmarkingCaseSchema).nullish(),
    scenariosCostRanking: GeneralHighlightsSchema.nullish(),
    createdAt: z.string().nullish(),
    deletedAt: z.string().nullish(),
    favoriteScenarioId: z.string().nullish(),
  })
  .superRefine((data, ctx) => {
    validateAllStepsAccumulate({ data, ctx });
  });
